import {
  USE_NEXT_PDP_EXPERIMENT_NAME,
  USE_NEXT_QUESTION_REVIEW_EXPERIMENT_NAME,
  IS_INDEXABLE_PAGE_REGEX,
  PDP_REGEX,
} from '@/constants/global';

// list of URLs that should be opened via a full refresh (don't use Nuxt/SPA)
const URL_WHITELIST_EXACT = ['/'];
const URL_WHITELIST_PREFIX = [
  '/collections/alternative-to/',
  '/asksumo/',
  '/browse/',
  '/search/',
  '/software/',
  '/creative-resources/',
  '/templates/',
  '/courses-learning/',
  '/collections/',
];

export default async ({ app, store }) => {
  const whitelistPrefix = [...URL_WHITELIST_PREFIX];
  const whitelistExact = [...URL_WHITELIST_EXACT];
  const whitelistRegexPrefix = [];

  await store.dispatch('experiments/getVariantsWithoutEnrolling', [
    USE_NEXT_PDP_EXPERIMENT_NAME,
  ]);

  // Enroll in experiments based on the current path on page load (as opposed to on route change)
  // Only do this client-side
  if (process.client) store.dispatch('experiments/enrollNextNuxtExperiments');

  const getExperimentVariant = store.getters['experiments/getExperimentVariant'];
  const isNextPDPEnabled = getExperimentVariant(USE_NEXT_PDP_EXPERIMENT_NAME) === 'enabled';
  const isIndexableQnREnabled = getExperimentVariant(USE_NEXT_QUESTION_REVIEW_EXPERIMENT_NAME) === 'enabled';

  if (isNextPDPEnabled) {
    whitelistRegexPrefix.push(PDP_REGEX);
  }

  if (isIndexableQnREnabled) {
    whitelistRegexPrefix.push(IS_INDEXABLE_PAGE_REGEX);
  }

  // add beforeEach handler once we are ready to avoid infinite loop
  app.router.onReady(() => {
    app.router.beforeEach((to, from, next) => {
      if (whitelistExact.some((url) => to.path === url)
          || whitelistPrefix.some((url) => to.path.startsWith(url))
          || whitelistRegexPrefix.some((regex) => regex.test(to.path))) {
        // Make sure to include any existing query params.
        let existingQueryParams = to.fullPath.split('?')[1] || '';
        if (existingQueryParams) {
          // Prepend the ? if there are existing query params.
          existingQueryParams = `?${existingQueryParams}`;
        }
        const newLocation = `${to.path}${existingQueryParams}`;
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.log(`[nextExperimentsRedirects] Redirecting to ${newLocation}`);
        }
        window.location.href = newLocation;
      } else {
        next();
      }
    });
    app.router.afterEach(() => {
      // Enroll in experiments based on the current path on route change
      // Only do this client-side
      if (process.client) store.dispatch('experiments/enrollNextNuxtExperiments');
    });
  });
};
